import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PasswordChangeForm } from "@/components/settings/profile/PasswordChangeForm";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const ChangePassword = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if there's a recovery token
    const token = localStorage.getItem('recovery_token');
    const email = localStorage.getItem('recovery_email');
    
    if (!token || !email) {
      // No recovery token found, redirect to auth
      navigate('/auth', { replace: true });
    }
  }, [navigate]);

  const handleSuccess = () => {
    // Clean up and redirect to auth
    localStorage.removeItem('recovery_token');
    localStorage.removeItem('recovery_email');
    navigate('/auth', { replace: true });
  };

  const handleBack = () => {
    navigate('/auth', { replace: true });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary to-primary-dark flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6">
        <div className="text-center space-y-2">
          <h1 className="text-3xl font-bold text-white">
            Cambiar Contraseña
          </h1>
          <p className="text-white/80">
            Ingresa tu nueva contraseña para completar la recuperación
          </p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-6">
          <PasswordChangeForm onCancel={handleSuccess} />
        </div>

        <Button
          type="button"
          variant="ghost"
          onClick={handleBack}
          className="w-full text-white hover:bg-white/10 flex items-center justify-center gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Volver al inicio de sesión
        </Button>
      </div>
    </div>
  );
};

export default ChangePassword;